// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginComponent_wrapper__ik65L","innerWrapper":"LoginComponent_innerWrapper__+J78f"};